var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('div',{staticClass:"mixer-db-layout"},[_c('main',{staticClass:"mixer-db-content"},[_c('router-view')],1)]):_c('div',[_vm._v("Access denied.")])}
var staticRenderFns = []

export { render, staticRenderFns }